import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import { useState } from 'react'
import { cn } from '../../utils/cn'

interface Props {
  message: string
  onConfirm: (confirm: boolean) => void
}

const Index = ({ onConfirm, message }: Props) => {
  const { t } = useTranslation()
  const [fadeOut, setFadeOut] = useState<boolean>(false)

  const closeConfirmation = (confirm: boolean) => {
    setFadeOut(true)
    setTimeout(() => {
      onConfirm(confirm)
    }, 500)
  }

  const arrowClassName = 'mx-[20px] my-0 lg:mx-[54px]'
  const buttonClassName = 'h-[60px] w-[250px] border-none bg-transparent p-0 text-center'
  const buttonLabelClassName =
    'font-approach-semi-bold text-[27px] leading-[50px] tracking-[1.62px] lg:text-[36px] lg:leading-[55px] min-[1600px]:text-[42px] min-[1600px]:leading-[60px]'

  return (
    <div
      className={cn(
        'fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center bg-black70',
        {
          'animate-[simple-fade-out_0.5s_ease_forwards]': fadeOut,
          'animate-[simple-fade-in_0.5s_ease_forwards]': !fadeOut,
        },
      )}
      onClick={() => closeConfirmation(false)}
    >
      <SVG className={arrowClassName} src="/icons/arrow.svg" />
      <div className="h-[196px] w-[400px] rounded-[12px] bg-white p-[20px] lg:w-[450px] min-[1600px]:w-[500px]">
        <h1 className="m-0 mt-[10px] text-center font-approach-regular text-[19px] leading-[30px] tracking-[0.4px] lg:text-[20px] min-[1600px]:text-[21px] min-[1600px]:leading-[32px] min-[1600px]:tracking-[0.5px]">
          {t(message)}
        </h1>
        <div className="mt-[20px] flex">
          <button className={buttonClassName} onClick={() => closeConfirmation(true)}>
            <span className={buttonLabelClassName}>{t('yes')}</span>
          </button>
          <button className={buttonClassName} onClick={() => closeConfirmation(false)}>
            <span className={buttonLabelClassName}>{t('no')}</span>
          </button>
        </div>
      </div>
      <SVG className={cn(arrowClassName, 'rotate-180')} src="/icons/arrow.svg" />
      <button
        className="fixed right-[120px] top-[30px] border-none bg-transparent p-0 text-white sm:top-[12vh] xl:right-[84px] xxl:right-[5vw]"
        onClick={() => closeConfirmation(false)}
      >
        <SVG className="m-0 size-[30px]" src="/icons/x.svg" />
      </button>
    </div>
  )
}

export default Index
